import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReversePipe } from './reverse.pipe';
import { AgePipe } from './age.pipe';
import { DateIntervalPipe } from './date-interval.pipe';
import { SafeHtml } from './safe-html.pipe';
import { TruncatePipe } from './truncate.pipe';

const all = [AgePipe, ReversePipe, DateIntervalPipe, SafeHtml, TruncatePipe];
@NgModule({
  imports: [CommonModule],
  declarations: [...all],
  exports: [...all]
})
export class PipesModule {}
